import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PdfViewerPageComponent } from './global/pdf-viewer-page.component';
import * as Component from './pages';
import { PublicComponent } from './public.component';
import * as PublicResources from './resolves';
import { AuthGuard } from './_guards';
import { CmsApiService, SessionStorageService } from './_services';

const routes: Routes = [
  {
    path: '',
    component: PublicComponent,
    resolve: { content: PublicResources.HeaderFooterResolver },
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },

      {
        path: 'home',
        component: Component.HomeComponent,
        resolve: { content: PublicResources.HomeResolver }
      },

      {
        path: 'features',
        component: Component.FeaturesComponent,
        resolve: { content: PublicResources.ProductPlansResolver }
      },

      {
        path: 'login',
        component: Component.LoginComponent,
        resolve: { content: PublicResources.LoginResolver }
      },

      {
        path: 'activate',
        component: Component.ActivateComponent,
        resolve: { content: PublicResources.ActivateResolver }
      },

      {
        path: 'forgotpassword',
        component: Component.ForgotpasswordComponent,
        resolve: { content: PublicResources.ForgotPasswordResolver }
      },

      {
        path: 'passwordrecovery',
        component: Component.ForgotpasswordSubmitComponent,
        resolve: { content: PublicResources.ForgotPasswordResolver }
      },

      {
        path: 'faqs',
        component: Component.StaticPublicComponent,
        resolve: { content: PublicResources.FaqResolver }
      },

      {
        path: 'privacy',
        component: Component.StaticPublicComponent,
        resolve: { content: PublicResources.PrivacyPolicyResolver }
      },

      {
        path: 'contact',
        component: Component.StaticPublicComponent,
        resolve: { content: PublicResources.ContactUsResolver }
      },

      {
        pathMatch: 'full',
        path: 'conditions',
        component: Component.ConditionsPageComponent,
        resolve: { content: PublicResources.ConditionsPageResolver }
      },

      { path: 'conditions/total', component: PdfViewerPageComponent },
      { path: 'conditions/systems', component: PdfViewerPageComponent },
      { path: 'conditions/appliances', component: PdfViewerPageComponent },

      { path: 'conditions/complet', component: PdfViewerPageComponent },
      { path: 'conditions/systemes', component: PdfViewerPageComponent },
      { path: 'conditions/appareilsem', component: PdfViewerPageComponent },

      { path: 'benefits/total', component: PdfViewerPageComponent },
      { path: 'benefits/systems', component: PdfViewerPageComponent },
      { path: 'benefits/appliances', component: PdfViewerPageComponent },

      { path: 'avantages/complet', component: PdfViewerPageComponent },
      { path: 'avantages/systemes', component: PdfViewerPageComponent },
      { path: 'avantages/appareilsem', component: PdfViewerPageComponent },

      {
        path: '404',
        component: Component.StaticPublicComponent,
        resolve: { content: PublicResources.Http404Resolver }
      }
    ]
  },

  { path: 'dash', canActivate: [AuthGuard], loadChildren: 'app/dash/dash.module#DashModule' },
  { path: '**', redirectTo: '404' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule],
  providers: [
    CmsApiService,
    SessionStorageService,
    PublicResources.HeaderFooterResolver,
    PublicResources.HomeResolver,
    PublicResources.ProductPlansResolver,
    PublicResources.LoginResolver,
    PublicResources.ActivateResolver,
    PublicResources.ForgotPasswordResolver,
    PublicResources.PrivacyPolicyResolver,
    PublicResources.ConditionsPageResolver,
    PublicResources.FaqResolver,
    PublicResources.ContactUsResolver,
    PublicResources.Http404Resolver
  ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts